export const APP_NAME = import.meta.env.VITE_PACKAGE_NAME;
export const ORIGIN_URL = import.meta.env.VITE_ORIGIN_URL;
export const COMPANY_ID = import.meta.env.VITE_COMPANY_ID;

export const CAR_SHEET_COMPANY = {
  name: '아이사랑카시트',
  url: 'https://smartstore.naver.com/babylove3',
  tel: '1588-3819',
};
